import { memo, FC } from 'react'
import { Icon } from '@chakra-ui/react'
import OUTLINES_ICONS from '../outlineIcons'
import TWO_TONE_ICONS from '../twoToneIcons'

type Props = {
  icon?: string
  color?: string
  boxSize?: number
  variant?: 'default' | 'twoTone'
}

const CustomIconViewer: FC<Props> = ({ icon, variant = 'twoTone', boxSize = 6 }) => {
  const ICONS = variant === 'twoTone' ? TWO_TONE_ICONS : OUTLINES_ICONS

  function getIcon() {
    const filter = ICONS.filter((item) => item.value === icon)
    if (filter[0]) {
      return filter[0].icon
    } else {
      return undefined
    }
  }

  if (!icon) {
    return <Icon color="primary" boxSize={boxSize} />
  }

  if (variant === 'twoTone') {
    return <Icon as={getIcon()} color="primary" variant="twoTone" boxSize={boxSize} />
  }

  return <Icon as={getIcon()} color="primary" boxSize={boxSize} />
}

export default memo(CustomIconViewer)
